class BjBackToTop extends HTMLElement {
  connectedCallback() {
    this._btn = this.querySelector('.bj-back-to-top__btn');
    if (!this._btn) return;

    this._btn.addEventListener('click', () => this._toTop());

    // Toggle visibility with an IntersectionObserver on a lightweight off-screen
    // sentinel rather than a scroll listener — no per-frame work, so no INP cost.
    // The sentinel spans the top ~80vh of the document; once it's fully scrolled
    // past, the user is roughly one screen down and the button appears.
    this._sentinel = document.createElement('div');
    this._sentinel.setAttribute('aria-hidden', 'true');
    Object.assign(this._sentinel.style, {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '1px',
      height: '80vh',
      pointerEvents: 'none',
      visibility: 'hidden',
    });
    document.body.appendChild(this._sentinel);

    this._observer = new IntersectionObserver(
      ([entry]) => { this.dataset.visible = String(!entry.isIntersecting); },
      { threshold: 0 }
    );
    this._observer.observe(this._sentinel);
  }

  _toTop() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    // Move focus to the top of the page content so keyboard / screen-reader users
    // continue from the top — not from a button that is about to hide (WCAG 2.4.3).
    const target = document.querySelector('#MainContent, main, [role="main"], h1');
    if (!target) return;
    const hadTabindex = target.hasAttribute('tabindex');
    if (!hadTabindex) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    if (!hadTabindex) {
      target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
    }
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    this._sentinel?.remove();
  }
}

customElements.define('bj-back-to-top', BjBackToTop);
